<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3>
          {{ this.routerName == "ChiTietDangKyDongHo" ? "CHI TIẾT" : "DUYỆT" }}
          ĐĂNG KÝ DÒNG HỌ
        </h3>
      </div>

      <div class="card-body">
        <div class="table-responsive-lg">
          <table class="table border">
            <thead>
              <tr>
                <th style="text-align: start !important">Trường thông tin</th>
                <th style="text-align: center">Người dùng hiện có</th>
                <th style="text-align: center">Đăng ký</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th style="text-align: start !important; width: 20%">
                  <el-form>
                    <el-form-item>Họ tên</el-form-item>
                    <el-form-item>Địa chỉ email</el-form-item>
                    <el-form-item>Xưng hô</el-form-item>
                    <el-form-item>Giới tính</el-form-item>
                    <el-form-item>Tên dòng họ</el-form-item>
                    <el-form-item>Khoảng đinh</el-form-item>
                    <template>
                      <el-form-item>Quốc Gia</el-form-item>
                    </template>
                    <template v-if="showTrongNuoc">
                      <div>
                        <el-form-item>Tỉnh/Thành phố</el-form-item>
                        <el-form-item>Quận/Huyện</el-form-item>
                        <el-form-item>Phường/Xã</el-form-item>
                      </div>
                    </template>
                    <el-form-item>Địa chỉ chi tiết</el-form-item>
                    <el-form-item>Số điện thoại</el-form-item>
                    <el-form-item>Mã giới thiệu</el-form-item>
                    <el-form-item>Thời điểm đăng ký</el-form-item>
                    <el-form-item></el-form-item>
                  </el-form>
                </th>

                <!-- bảng form thông tin người dùng hiện có -->

                <td style="width: 40%">
                  <el-form
                    :model="mData.dataFormServer"
                    ref="formServer"
                    :rules="mData.validForm"
                  >
                    <el-form-item prop="ten.ho_ten">
                      <el-input
                        v-model="mData.dataFormServer.ten.ho_ten"
                        :disabled="
                          !isDataServer ||
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi'
                        "
                        placeholder="Chưa có thông tin"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      prop="thong_tin_lien_lac.email"
                      :rules="[
                        {
                          required: true,
                          message: 'Vui lòng nhập gmail',
                          trigger: 'blur',
                        },
                        {
                          type: 'email',
                          message: 'Gmail chưa đúng vui lòng nhập lại',
                          trigger: ['blur', 'change'],
                        },
                      ]"
                    >
                      <el-input
                        v-model="mData.dataFormServer.thong_tin_lien_lac.email"
                        :disabled="
                          !isDataServer ||
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi'
                        "
                        placeholder="Chưa có thông tin"
                        type="email"
                      ></el-input>
                    </el-form-item>
                    <el-form-item prop="ten.xung_ho">
                      <el-select
                        v-model="mData.dataFormServer.ten.xung_ho"
                        :disabled="
                          !isDataServer ||
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi'
                        "
                        placeholder="Chưa có thông tin"
                      >
                        <el-option
                          v-for="item in mData.xungHo"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="mData.dataFormServer.gioi_tinh"
                        placeholder="Chưa có thông tin"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          !isDataServer
                        "
                        @change="fn_changeGioiTinh"
                      >
                        <el-option
                          v-for="item in optionsGioiTinh"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item style="visibility: hidden">
                      <el-input></el-input>
                    </el-form-item>
                    <el-form-item style="visibility: hidden">
                      <el-input></el-input>
                    </el-form-item>
                    <el-form-item style="visibility: hidden">
                      <el-input></el-input>
                    </el-form-item>
                    <div v-if="showTrongNuoc">
                      <el-form-item style="visibility: hidden">
                        <el-input></el-input>
                      </el-form-item>
                      <el-form-item style="visibility: hidden">
                        <el-input></el-input>
                      </el-form-item>
                      <el-form-item style="visibility: hidden">
                        <el-input></el-input>
                      </el-form-item>
                    </div>
                    <el-form-item style="visibility: hidden">
                      <el-input></el-input>
                    </el-form-item>
                    <el-form-item style="visibility: hidden">
                      <el-input></el-input>
                    </el-form-item>
                    <el-form-item style="visibility: hidden">
                      <el-input></el-input>
                    </el-form-item>
                    <el-form-item style="visibility: hidden">
                      <el-input></el-input>
                    </el-form-item>
                    <el-form-item style="visibility: hidden">
                      <el-input></el-input>
                    </el-form-item>
                    <div style="text-align: center">
                      <el-button
                        type="success"
                        plain
                        @click="fn_checkValidateServer()"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          !isDataServer
                        "
                        >Cập nhật</el-button
                      >
                    </div>
                  </el-form>
                </td>

                <!-- bảng form thông tin người dùng đăng ký mới -->
                <td style="width: 40%">
                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="formUser"
                  >
                    <el-form-item prop="ho_ten">
                      <el-input
                        v-model="mData.dataForm.ho_ten"
                        placeholder="Chưa có thông tin"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          this.routerName == 'ChiTietDangKyDongHo'
                        "
                        v-bind:class="{ error: isErrorHoTen }"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      prop="email"
                      :rules="[
                        {
                          required: true,
                          message: 'Vui lòng nhập email',
                          trigger: 'blur',
                        },
                        {
                          type: 'email',
                          message: 'Email chưa đúng vui lòng nhập lại',
                          trigger: ['blur', 'change'],
                        },
                      ]"
                    >
                      <el-input
                        v-model="mData.dataForm.email"
                        @change="fn_changeEmail()"
                        placeholder="Chưa có thông tin"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          this.routerName == 'ChiTietDangKyDongHo'
                        "
                        v-bind:class="{ error: isErrorEmail }"
                        type="email"
                      ></el-input>
                    </el-form-item>
                    <el-form-item prop="xung_ho">
                      <!-- <el-input v-model="mData.dataForm.xung_ho" placeholder="Chưa có thông tin" v-bind:class="{ error: isErrorXungHo }"></el-input> -->
                      <el-select
                        v-model="mData.dataForm.xung_ho"
                        placeholder="Chưa có thông tin"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          this.routerName == 'ChiTietDangKyDongHo'
                        "
                        v-bind:class="{ error: isErrorXungHo }"
                      >
                        <el-option
                          v-for="item in mData.xungHo"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item style="visibility: hidden">
                      <el-input></el-input>
                    </el-form-item>
                    <el-form-item prop="ten_dong_ho">
                      <el-input
                        v-model="mData.dataForm.ten_dong_ho"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          this.routerName == 'ChiTietDangKyDongHo'
                        "
                        placeholder="Chưa có thông tin"
                      ></el-input>
                    </el-form-item>
                    <b-row>
                      <b-col md="12">
                        <el-form-item prop="khoang_dinh">
                          <el-select
                            v-model="mData.dataForm.khoang_dinh.tu"
                            :disabled="
                              this.trangThai == 'da_duyet' ||
                              this.trangThai == 'tu_choi' ||
                              this.routerName == 'ChiTietDangKyDongHo'
                            "
                            placeholder="Chọn khoảng đinh"
                          >
                            <el-option
                              v-for="item in mData.khoangDinh"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>

                    <el-form-item prop="quoc_gia_id">
                      <el-select
                        v-model="mData.dataForm.quoc_gia_id"
                        @change="fn_changeQuocGia"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          this.routerName == 'ChiTietDangKyDongHo'
                        "
                        placeholder="Chưa có thông tin"
                        filterable
                      >
                        <el-option
                          v-for="item in listQuocGia"
                          :key="item.id"
                          :label="item.ten_quoc_gia.vi"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <template v-if="showTrongNuoc">
                      <div>
                        <el-form-item prop="tinh_id">
                          <el-select
                            v-model="mData.dataForm.tinh_id"
                            @change="fn_changeTinh"
                            :disabled="
                              this.trangThai == 'da_duyet' ||
                              this.trangThai == 'tu_choi' ||
                              this.routerName == 'ChiTietDangKyDongHo'
                            "
                            placeholder="Chưa có thông tin"
                            filterable
                          >
                            <el-option
                              v-for="item in listTinh"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item prop="huyen_id">
                          <el-select
                            v-model="mData.dataForm.huyen_id"
                            @change="fn_changeHuyen"
                            :disabled="
                              this.trangThai == 'da_duyet' ||
                              this.trangThai == 'tu_choi' ||
                              this.routerName == 'ChiTietDangKyDongHo'
                            "
                            placeholder="Chưa có thông tin"
                            filterable
                          >
                            <el-option
                              v-for="item in listHuyen"
                              :key="item.value"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item prop="xa_id">
                          <el-select
                            v-model="mData.dataForm.xa_id"
                            :disabled="
                              this.trangThai == 'da_duyet' ||
                              this.trangThai == 'tu_choi' ||
                              this.routerName == 'ChiTietDangKyDongHo'
                            "
                            placeholder="Chưa có thông tin"
                            filterable
                          >
                            <el-option
                              v-for="item in listXa"
                              :key="item.value"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </template>

                    <el-form-item prop="dia_chi">
                      <el-input
                        v-model="mData.dataForm.dia_chi"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          this.routerName == 'ChiTietDangKyDongHo'
                        "
                        placeholder="Chưa có thông tin"
                      ></el-input>
                    </el-form-item>
                    <el-form-item prop="dien_thoai">
                      <el-input
                        v-model="mData.dataForm.dien_thoai"
                        placeholder="Chưa có thông tin"
                        disabled
                      ></el-input>
                    </el-form-item>
                    <el-form-item prop="ma_gioi_thieu">
                      <el-input
                        v-model="mData.dataForm.ma_gioi_thieu"
                        placeholder="Chưa có thông tin"
                        clearable
                        @change="
                          () => {
                            mData.dataForm.ma_gioi_thieu =
                              mData.dataForm.ma_gioi_thieu.toUpperCase();
                          }
                        "
                      />
                    </el-form-item>
                    <el-form-item prop="thoi_diem_tao">
                      <el-input
                        v-model="mData.dataForm.thoi_diem_tao"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          this.routerName == 'ChiTietDangKyDongHo'
                        "
                        placeholder="Chưa có thông tin"
                      ></el-input>
                    </el-form-item>
                    <el-form-item prop="dia_chi">
                      <el-checkbox
                        v-model="trongHo"
                        :disabled="
                          this.trangThai == 'da_duyet' ||
                          this.trangThai == 'tu_choi' ||
                          this.routerName == 'ChiTietDangKyDongHo'
                        "
                        >Con dâu, con rể</el-checkbox
                      >
                    </el-form-item>
                    <div style="text-align: center">
                      <el-button
                        type="success"
                        plain
                        @click="fn_checkValidateUser()"
                        :disabled="
                          trangThai == 'da_duyet' ||
                          trangThai == 'tu_choi' ||
                          this.routerName == 'ChiTietDangKyDongHo'
                        "
                        >Cập nhật</el-button
                      >
                    </div>
                  </el-form>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-checkbox
          v-model="chuyenDangXuLy"
          @change="fn_chuyenDangXuLy"
          :disabled="
            this.trangThai == 'da_duyet' ||
            this.trangThai == 'tu_choi' ||
            this.trangThai == 'dang_xu_ly' ||
            this.routerName == 'ChiTietDangKyDongHo'
          "
          style="margin-bottom: 20px"
          >Chuyển trạng thái đang xử lý</el-checkbox
        >
        <!-- lịch sử đăng ký -->
        <LichSuDangKy
          :phone="phoneUser"
          :thoiDiemTao="thoiDiemTao"
          :trangThaiDuyet="trangThai"
          :liDo="liDoTuChoi"
        />

        <!-- đăng ký phản hồi -->
        <div class="mt-3">
          <el-collapse
            @change="handleNoiDungPhanHoi()"
            v-model="activeNamesPhanHoi"
          >
            <el-collapse-item name="1">
              <template slot="title">
                <i class="fas fa-history"></i> LỊCH SỬ PHẢN HỒI
                <span class="value-list">{{
                  this.danhSachPhanHoi.length
                }}</span>
              </template>
              <div class="phan-hoi-radio">
                <el-radio
                  v-model="trangThaiEmail"
                  label="gui"
                  style="margin-right: 15px"
                  >Gửi email</el-radio
                >
                <el-radio v-model="trangThaiEmail" label="luu"
                  >Nhận email</el-radio
                >
              </div>
              <el-input
                type="textarea"
                :rows="11"
                placeholder="Nhập nội dung phản hồi"
                v-model="noiDungPhanHoi"
              >
              </el-input>
              <div class="text-center mt-2 group-btn-email">
                <el-button
                  type="primary"
                  :disabled="noiDungPhanHoi.trim() == ''"
                  v-show="trangThaiEmail == 'gui'"
                  @click="fn_guiPhanHoi('viettoc')"
                  icon="el-icon-upload2"
                  >Gửi</el-button
                >
                <el-button
                  type="primary"
                  :disabled="noiDungPhanHoi.trim() == ''"
                  v-show="trangThaiEmail == 'luu'"
                  @click="fn_guiPhanHoi('khach')"
                  icon="el-icon-download"
                  >Lưu</el-button
                >
              </div>

              <div>
                <div
                  v-for="item in danhSachPhanHoi"
                  :key="item.id"
                  class="lich-su mt-3"
                >
                  <div class="collapse-content__time">
                    <div v-if="item.nguoi_gui == 'viettoc'">
                      <i class="fas fa-user-headset"></i>
                    </div>
                    <div v-else>
                      <i class="fas fa-user"></i>
                    </div>
                    <div class="lich-su__time">{{ item.thoi_diem_tao }}</div>
                  </div>

                  <div class="lich-su__content">
                    <p style="white-space: pre-line">{{ item.noi_dung }}</p>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <!--  ghi chú phản hồi-->

        <div class="mt-3">
          <el-collapse
            @change="handleNoiDungGhiChu()"
            v-model="activeNamesGhiChu"
          >
            <el-collapse-item name="1">
              <template slot="title">
                <i class="fal fa-notes-medical"></i> GHI CHÚ
                <span class="value-list">{{ this.danhSachGhiChu.length }}</span>
              </template>
              <el-input
                type="textarea"
                :rows="10"
                placeholder="Nhập nội dung ghi chú"
                v-model="noiDungGhiChu"
              >
              </el-input>
              <div class="text-center mt-2 group-btn-email">
                <el-button
                  type="primary"
                  :disabled="noiDungGhiChu.trim() == ''"
                  @click="fn_guiGhiChu()"
                  >Lưu</el-button
                >
              </div>

              <div>
                <div
                  v-for="item in danhSachGhiChu"
                  :key="item.id"
                  class="lich-su mt-3"
                >
                  <div class="collapse-content__time">
                    <div class="lich-su__ghi-chu">{{ item.thoi_diem_tao }}</div>
                  </div>

                  <div class="lich-su__content">
                    <p style="white-space: pre-line">{{ item.noi_dung }}</p>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- từ chối, duyệt đăng ký -->
        <el-form id="formUser">
          <el-form-item label=""></el-form-item>
          <div class="btn-group">
            <el-button plain @click="fn_back()">Quay lại</el-button>
            <el-button
              type="danger"
              plain
              @click="fn_showTuChoi()"
              :disabled="
                trangThai == 'da_duyet' ||
                trangThai == 'tu_choi' ||
                this.routerName == 'ChiTietDangKyDongHo'
              "
              >Từ chối</el-button
            >
            <el-button
              type="primary"
              @click="fn_showDuyet()"
              :disabled="
                trangThai == 'da_duyet' ||
                trangThai == 'tu_choi' ||
                this.routerName == 'ChiTietDangKyDongHo'
              "
              >Duyệt đăng ký</el-button
            >
          </div>
        </el-form>
      </div>

      <!-- thông báo cho phép cập nhật người dùng đăng ký mới, hiện có -->
      <el-dialog
        :title="this.thong_bao_duyet ? 'duyệt dòng họ' : 'thông báo'"
        :visible.sync="dialogThongBao"
        width="30%"
        center
      >
        <div
          style="word-break: break-word; text-align: center"
          v-if="this.thong_bao_user"
        >
          Bạn có chắc chắn cập nhật lại thông tin người dùng đăng ký mới?
        </div>

        <div
          style="word-break: break-word; text-align: center"
          v-if="this.thong_bao_server"
        >
          Bạn có chắc chắn cập nhật lại thông tin người dùng hiện có?
        </div>

        <div
          style="word-break: break-word; text-align: center"
          v-if="this.thong_bao_duyet"
        >
          Bạn có chắc chắn duyệt dòng họ này?
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogThongBao = false">Hủy</el-button>
          <el-button
            type="primary"
            v-if="this.thong_bao_user"
            @click="fn_updateUser()"
            :loading="loadingButton"
            >Đồng ý</el-button
          >
          <el-button
            type="primary"
            v-if="this.thong_bao_server"
            @click="fn_updateServer()"
            :loading="loadingButton"
            >Đồng ý</el-button
          >
          <el-button
            type="primary"
            v-if="this.thong_bao_duyet"
            @click="fn_duyetUser()"
            :loading="loadingButton"
            >Đồng ý</el-button
          >
        </span>
      </el-dialog>

      <!-- thông báo từ chối duyệt đăng ký mới -->
      <el-dialog
        title="Từ chối duyệt đăng ký"
        :visible.sync="dialogTuChoi"
        width="60%"
        center
        :before-close="fn_resetFormTuChoiDuyetUser"
      >
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="formTuChoiDuyetUser"
        >
          <el-form-item prop="li_do_tu_choi">
            <el-input
              placeholder="Nhập lý do từ chối"
              v-model="mData.dataForm.li_do_tu_choi"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="sendEmail">Gửi email từ chối</el-checkbox>
          </el-form-item>
          <div style="text-align: center; margin-top: 30px">
            <el-button type="danger" @click="fn_tuChoiDuyetUser()"
              >Từ chối</el-button
            >
          </div>
        </el-form>
      </el-dialog>
      <DialogDuyetDongKo
        :configModal="showFormService"
        :dataDanhKyDongHo="mData.dataFormDangKy"
        @submit="submitForm"
        @close="handleCloseDialogChooseService"
      />
    </div>
  </div>
</template>

<script>
import mushroom from "viettoc-api";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormDangKyDongHo";
import DataFormServer from "../../../dataForm/dataFormNguoiDung";
import ValidService from "../../../service/ValidService";
import LichSuDangKy from "../DangKy/LichSuDangKy.vue";
import { Circle4 } from "vue-loading-spinner";
import eventBus from "../../../service/EventBus";
import DialogDuyetDongKo from "./DialogDuyetDongKo.vue";

export default {
  components: {
    Circle4,
    LichSuDangKy,
    DialogDuyetDongKo,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      activeNamesPhanHoi:
        this.$router.currentRoute.name === "ChiTietDangKyDongHo"
          ? ["1"]
          : ["2"],
      activeNamesGhiChu:
        this.$router.currentRoute.name === "ChiTietDangKyDongHo"
          ? ["1"]
          : ["2"],
      routerName: "",
      linkAgent: null,
      loading: true,
      loadingButton: false,
      dialogThongBao: false,
      dialogTuChoi: false,
      thong_bao_user: false,
      thong_bao_server: false,
      thong_bao_duyet: false,
      isErrorHoTen: false,
      isErrorEmail: false,
      isErrorXungHo: false,
      phoneUser: "",
      textarea: "",
      isDataServer: false,
      trangThai: "",
      liDoTuChoi: "",
      thoiDiemTao: "",
      trongHo: "",
      listQuocGia: [],
      listTinh: [],
      listHuyen: [],
      listXa: [],
      noiDungPhanHoi: "",
      noiDungGhiChu: "",
      danhSachPhanHoi: [],
      danhSachGhiChu: [],
      trangThaiEmail: "",
      sendEmail: true,
      gioiTinh: "",
      chuyenDangXuLy: false,
      optionsGioiTinh: [
        { value: "nam", label: "Nam" },
        { value: "nu", label: "Nữ" },
        { value: "khac", label: "Khác" },
      ],
      showTrongNuoc: true,
      showFormService: {
        show: false,
      },
      mData: {
        dataFormDangKy: undefined,
        dataFormServer: MethodService.copyObject(DataFormServer.dataForm),
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        xungHo: MethodService.copyObject(DataForm.xungHo),
        khoangDinh: MethodService.copyObject(DataForm.khoangDinh),

        // chưa hiểu tại sao không validate từ trong ValidService.js được
        validForm: {
          "ten.ho_ten": [ValidService.required],
          ho_ten: [ValidService.required],
          email: [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkEmail,
          ],
          "thong_tin_lien_lac.email": [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkEmail,
          ],
          "ten.xung_ho": [ValidService.required],
          ten_dong_ho: [ValidService.required],
          ten_quoc_gia: [ValidService.required],
          dia_chi: [ValidService.required],
          li_do_tu_choi: [ValidService.required],
          "khoang_dinh.tu": [ValidService.required],
          "khoang_dinh.den": [ValidService.required],
          ma_gioi_thieu: [
            {
              pattern: /^gt\d{6}$/i,
              message: "Mã giới thiệu có định dạng là GT + 6 chữ số",
              trigger: ["blur", "change"],
            },
          ],
        },
        dataApplyServicePack: undefined,
      },
    };
  },
  methods: {
    async fn_initForm() {
      try {
        // lấy thông tin từ user đăng ký
        const responseUser = await mushroom.dang_ky.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields:
            "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,trong_ho,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_duyet,ma_gioi_thieu",
        });
        this.mData.dataFormDangKy = responseUser.result;

        // let resData = await this.fn_changeData(responseUser.result);
        // this.mData.dataForm = resData;
        if (responseUser.result.trang_thai == "dang_xu_ly") {
          this.chuyenDangXuLy = true;
        } else this.chuyenDangXuLy = false;

        this.phoneUser = responseUser.result.dien_thoai;
        this.thoiDiemTao = responseUser.result.thoi_diem_tao;
        if (responseUser.result.ma_gioi_thieu) {
          let ma = responseUser.result.ma_gioi_thieu.replace("GT", "");
          const resAgent = await mushroom.agt_dai_ly.listAsync({
            filters: ["ma=" + ma],
          });
          console.log("resAgent", resAgent);
          if (resAgent.result && resAgent.result.length > 0)
            this.linkAgent =
              location.origin +
              "/admin/dai-ly/chi-tiet/" +
              resAgent.result[0].id;
        }

        let resDataUser = await this.fn_changeData(responseUser.result);
        this.mData.dataForm = resDataUser;
        if (responseUser.result.quoc_gia_id) {
          const responseQuocGia = await mushroom.quoc_gia.findByIdAsync({
            id: responseUser.result.quoc_gia_id, // required
          });
          if (responseQuocGia.result.ma.alpha_2 === "VN") {
            this.showTrongNuoc = true;
          } else {
            this.showTrongNuoc = false;
          }
        }
        this.trangThai = responseUser.result.trang_thai;
        this.liDoTuChoi = responseUser.result.li_do_tu_choi;
        this.trongHo = !responseUser.result.trong_ho;
        if (responseUser.result.khoang_dinh.tu) {
          this.mData.dataForm.khoang_dinh_tu =
            responseUser.result.khoang_dinh.tu;
        } else this.mData.dataForm.khoang_dinh_tu = 1;

        if (
          !responseUser.result.khoang_dinh.tu ||
          responseUser.result.khoang_dinh.den == 100
        ) {
          responseUser.result.khoang_dinh.tu = 1;
        }
        this.fn_getQuocGia();
        this.fn_getTenTinh();
        this.fn_getTenHuyen();
        this.fn_getTenXa();
        // lấy thông tin người dùng từ server theo số điện thoại
        const responseServer = await mushroom.nguoi_dung.listAsync({
          fields:
            "id,quan_he,ten,avatar_id,gioi_tinh,sinh,mat,dia_chi,thong_tin_lien_lac,giay_to,hoc_van,cong_viec,sinh_ton,ton_giao_id,user_id,kich_hoat",
          filters: ["thong_tin_lien_lac.dien_thoai=" + this.phoneUser],
        });
        if (responseServer.result[0]) {
          this.mData.dataFormServer = responseServer.result[0];

          this.idUser = responseServer.result[0].id;
          this.isDataServer = true;
        }
        if (
          this.mData.dataForm.ho_ten !== this.mData.dataFormServer.ten.ho_ten &&
          responseServer.result[0]
        ) {
          this.isErrorHoTen = true;
        } else {
          this.isErrorHoTen = false;
        }
        if (
          this.mData.dataForm.email !==
            this.mData.dataFormServer.thong_tin_lien_lac.email &&
          responseServer.result[0]
        ) {
          this.isErrorEmail = true;
        } else {
          this.isErrorEmail = false;
        }
        if (
          this.mData.dataForm.xung_ho !==
            this.mData.dataFormServer.ten.xung_ho &&
          responseServer.result[0]
        ) {
          this.isErrorXungHo = true;
        } else {
          this.isErrorXungHo = false;
        }
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
        window.toastr.error("Đã có lỗi xảy ra");
        this.loading = false;
      }
    },
    fn_changeGioiTinh(event) {
      this.gioiTinh = event;
    },
    fn_changeData(data) {
      data.dien_thoai = MethodService.formatPhone(data.dien_thoai);
      data.thoi_diem_tao = MethodService.formatDate(
        data.thoi_diem_tao,
        "datetime"
      );
      return data;
    },

    async fn_chuyenDangXuLy() {
      const xu_ly_object = {
        id: this.$router.currentRoute.params.id,
        trang_thai: "dang_xu_ly",
      };
      try {
        const response = await mushroom.dang_ky.partialUpdateAsync(
          xu_ly_object
        );
        if (response.result == this.$router.currentRoute.params.id) {
          this.trangThaiDuyet = "dang_xu_ly";
          await this.fn_initForm();
        }
      } catch (error) {
        console.error(error);
      }
    },

    async fn_getQuocGia() {
      const response = await mushroom.quoc_gia.listAsync();
      this.listQuocGia = response.result;
      if (
        !this.mData.dataForm.quoc_gia_id ||
        this.mData.dataForm.quoc_gia_id.length === 0
      ) {
        this.mData.dataForm.quoc_gia_id = response.result.find(
          (item) => item.ma.alpha_2 === "VN"
        ).id;
      }
    },
    async fn_getTenTinh() {
      const resTinh = await mushroom.province.listAsync({
        limit: 100,
      });
      this.listTinh = resTinh.result;
    },

    async fn_getTenHuyen() {
      if (this.mData.dataForm.tinh_id) {
        const resHuyen = await mushroom.district.listAsync({
          filters: ["provinceId=" + this.mData.dataForm.tinh_id],
        });
        this.listHuyen = resHuyen.result;
      }
    },

    async fn_getTenXa() {
      if (this.mData.dataForm.huyen_id) {
        const resXa = await mushroom.commune.listAsync({
          filters: ["districtId=" + this.mData.dataForm.huyen_id],
        });
        this.listXa = resXa.result;
      }
    },
    fn_changeEmail() {
      this.mData.dataForm.email = this.mData.dataForm.email.toLowerCase();
    },
    fn_changeKhoangDinh() {
      this.fn_getTenHuyen();
    },
    async fn_changeQuocGia(item) {
      this.mData.dataForm.quoc_gia_id = item;
      if (item) {
        const response = await mushroom.quoc_gia.findByIdAsync({
          id: item, // required
        });
        if (response.result.ma.alpha_2 === "VN") {
          this.showTrongNuoc = true;
        } else {
          this.showTrongNuoc = false;
        }
      }
    },
    // fn_changeKhoangDinh(event) {
    //   this.fn_getTenHuyen();
    // },
    fn_changeTinh(item) {
      this.mData.dataForm.tinh_id = item;
      this.mData.dataForm.huyen_id = "";
      this.mData.dataForm.xa_id = "";
      this.fn_getTenHuyen();
    },
    fn_changeHuyen(item) {
      this.mData.dataForm.huyen_id = item;
      this.mData.dataForm.xa_id = "";
      this.fn_getTenXa();
    },

    fn_checkValidateUser() {
      this.$refs["formUser"].validate((valid) => {
        if (valid) {
          this.dialogThongBao = true;
          this.thong_bao_user = true;
          this.thong_bao_duyet = false;
          this.thong_bao_server = false;
        }
      });
    },
    fn_checkValidateServer() {
      this.$refs["formServer"].validate((valid) => {
        if (valid) {
          this.dialogThongBao = true;
          this.thong_bao_user = false;
          this.thong_bao_duyet = false;
          this.thong_bao_server = true;
        }
      });
    },

    async fn_updateUser() {
      this.loadingButton = true;
      //gán giá trị khoảng đinh đến
      if (this.mData.dataForm.khoang_dinh.tu == 1) {
        this.mData.dataForm.khoang_dinh.den = 100;
      } else if (this.mData.dataForm.khoang_dinh.tu == 100) {
        this.mData.dataForm.khoang_dinh.den = 200;
      } else if (this.mData.dataForm.khoang_dinh.tu == 200) {
        this.mData.dataForm.khoang_dinh.den = 300;
      } else if (this.mData.dataForm.khoang_dinh.tu == 300) {
        this.mData.dataForm.khoang_dinh.den = 500;
      } else if (this.mData.dataForm.khoang_dinh.tu == 500) {
        this.mData.dataForm.khoang_dinh.den = 1000;
      } else if (this.mData.dataForm.khoang_dinh.tu == 1000) {
        this.mData.dataForm.khoang_dinh.den = 3000;
      } else if (this.mData.dataForm.khoang_dinh.tu == 3000) {
        this.mData.dataForm.khoang_dinh.den = 999999;
      }
      let update_dang_ky_object = {
        id: this.$router.currentRoute.params.id,
        ten_dong_ho: this.mData.dataForm.ten_dong_ho, // required
        quoc_gia_id: this.mData.dataForm.quoc_gia_id,
        tinh_id: this.mData.dataForm.tinh_id,
        huyen_id: this.mData.dataForm.huyen_id,
        xa_id: this.mData.dataForm.xa_id,
        dia_chi: this.mData.dataForm.dia_chi,
        xung_ho: this.mData.dataForm.xung_ho,
        ho_ten: this.mData.dataForm.ho_ten, // required
        email: this.mData.dataForm.email.toLowerCase(), // required
        trong_ho: !this.trongHo,
        khoang_dinh: {
          tu: this.mData.dataForm.khoang_dinh.tu,
          den: this.mData.dataForm.khoang_dinh.den,
        },
        ma_gioi_thieu: this.mData.dataForm.ma_gioi_thieu,
      };
      try {
        const response = await mushroom.dang_ky.partialUpdateAsync(
          update_dang_ky_object
        );
        if (response.result == this.$router.currentRoute.params.id) {
          this.dialogThongBao = false;
          window.toastr.success("Cập nhật đăng ký mới người dùng thành công");
          await this.fn_initForm();
        } else {
          window.toastr.warning("Dữ liệu không thay đổi");
        }
        this.loadingButton = false;
      } catch (error) {
        console.error(error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Gặp sự cố tải dữ liệu");
        } else {
          window.toastr.error("Đã có lỗi xảy ra");
        }
        this.dialogThongBao = false;
        this.loadingButton = false;
      }
    },
    async fn_updateServer() {
      this.loadingButton = true;
      const nguoi_dung_object = {
        id: this.idUser,
        ten: {
          ho_ten: this.mData.dataFormServer.ten.ho_ten,
          xung_ho: this.mData.dataFormServer.ten.xung_ho,
        },
        thong_tin_lien_lac: {
          email: this.mData.dataFormServer.thong_tin_lien_lac.email,
        },
        gioi_tinh: this.mData.dataFormServer.gioi_tinh,
      };
      try {
        const response = await mushroom.nguoi_dung.partialUpdateAsync(
          nguoi_dung_object
        );
        if (response.result == this.idUser) {
          await this.fn_initForm();
          window.toastr.success("Cập nhật người dùng hiện có thành công");
        } else window.toastr.warning("Dữ liệu người dùng không thay đổi");
        this.dialogThongBao = false;
        this.loadingButton = false;
      } catch (error) {
        console.error("Có lỗi: %o", error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Gặp sự cố tải dữ liệu");
        } else {
          window.toastr.error("Đã có lỗi xảy ra");
        }
        this.loadingButton = false;
      }
    },
    async fn_duyetUser() {
      this.loadingButton = true;
      this.dialogThongBao = false;
      const duyet_dang_ky_object = this.mData.dataApplyServicePack;
      try {
        const response = await mushroom.dong_ho.dangKyDongHoAsync({
          body: duyet_dang_ky_object,
        });
        if (response.result) {
          this.trangThai = "da_duyet";
          window.toastr.success("Duyệt dòng họ thành công");
          this.handleCloseDialogChooseService();
          eventBus.$emit("duyetDangKyDongHo");
          this.loadingButton = false;
        }
      } catch (error) {
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Gặp sự cố tải dữ liệu");
        } else {
          window.toastr.error(error.message);
        }
        this.loadingButton = false;
      }
    },
    fn_duyetServer() {
      this.dialogThongBao = false;
    },

    fn_showTuChoi() {
      this.dialogTuChoi = true;
    },
    fn_showDuyet() {
      // this.dialogThongBao = true;
      // this.thong_bao_user = false;
      // this.thong_bao_server = false;
      // this.thong_bao_duyet = true;
      this.showFormService.show = true;
    },
    fn_showDialogDuyet() {
      this.showFormService.show = true;
    },

    fn_resetFormTuChoiDuyetUser() {
      this.$refs["formTuChoiDuyetUser"].resetFields();
      this.dialogTuChoi = false;
    },
    fn_tuChoiDuyetUser() {
      this.$refs["formTuChoiDuyetUser"].validate(async (valid) => {
        if (valid) {
          this.dialogTuChoi = false;

          // cập nhật đăng ký user thêm trường li_do_tu_choi
          const tu_choi_dang_ky_object = {
            id: this.$router.currentRoute.params.id,
            li_do_tu_choi: this.mData.dataForm.li_do_tu_choi,
            trang_thai: "tu_choi",
            gui_mail_tu_choi: this.sendEmail,
          };
          try {
            const response = await mushroom.dang_ky.partialUpdateAsync(
              tu_choi_dang_ky_object
            );
            if (response.result == this.$router.currentRoute.params.id) {
              this.mData.dataForm.li_do_tu_choi = "";
              window.toastr.success("Đã từ chối đăng ký dòng họ mới");
              this.liDoTuChoi = this.mData.dataForm.li_do_tu_choi;
              this.trangThai = "tu_choi";
              await this.fn_initForm();
              eventBus.$emit("duyetDangKyDongHo");
            } else {
              window.toastr.warning(
                "Từ chối đăng ký dòng họ mới không thành công"
              );
            }
          } catch (error) {
            console.error(error);
            if (error.code === 4) {
              window.toastr.error(this.aLang.no_server);
            } else if (error.code === 2) {
              window.toastr.error("Gặp sự cố tải dữ liệu");
            } else window.toastr.error("Đã có lỗi xảy ra");
          }
        } else {
          return false;
        }
      });
    },

    // quay lại danh sách đăng ký dòng họ
    fn_back() {
      this.$router.go(-1);
    },

    // nội dung phản hồi
    handleNoiDungPhanHoi(val) {
      this.noiDungPhanHoi = "";
      this.trangThaiEmail = "";
    },
    handleNoiDungGhiChu(val) {
      this.noiDungGhiChu = "";
    },
    async fn_guiPhanHoi(nguoiGui) {
      const dang_ky_phan_hoi_object = {
        dang_ky_id: this.$router.currentRoute.params.id,
        noi_dung: this.noiDungPhanHoi,
        nguoi_gui: nguoiGui,
      };
      try {
        const newId = await mushroom.dang_ky_phan_hoi.createAsync(
          dang_ky_phan_hoi_object
        );
        if (newId.result) {
          window.toastr.success("Gửi phản hồi thành công");
          this.noiDungPhanHoi = "";
          await this.fn_getNoiDungPhanHoi();
        }
      } catch (error) {
        console.error("Có lỗi: %o", error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
    },

    async fn_getNoiDungPhanHoi() {
      try {
        const response = await mushroom.dang_ky_phan_hoi.listAsync({
          fields: "id,dang_ky_id,noi_dung,nguoi_gui,thoi_diem_tao,nguoi_tao_id",
          filters: ["dang_ky_id=" + this.$router.currentRoute.params.id],
          sort: "-thoi_diem_tao",
        });
        let noiDung = await this.fn_changeDataPhanHoiGhiChu(response.result);
        this.danhSachPhanHoi = [];
        noiDung.forEach((item) => {
          this.danhSachPhanHoi.push({
            nguoi_gui: item.nguoi_gui,
            noi_dung: item.noi_dung,
            thoi_diem_tao: item.thoi_diem_tao,
          });
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    fn_changeDataPhanHoiGhiChu(data) {
      data.forEach((element) => {
        element.thoi_diem_tao = MethodService.formatDate(
          element.thoi_diem_tao,
          "datetime"
        );
      });
      return data;
    },

    async fn_guiGhiChu() {
      const dang_ky_ghi_chu_object = {
        dang_ky_id: this.$router.currentRoute.params.id,
        noi_dung: this.noiDungGhiChu,
      };
      try {
        const newId = await mushroom.dang_ky_ghi_chu.createAsync(
          dang_ky_ghi_chu_object
        );
        if (newId.result) {
          window.toastr.success("Lưu ghi chú thành công");
          this.noiDungGhiChu = "";
          await this.fn_getNoiDungGhiChu();
        }
      } catch (error) {
        console.error("Có lỗi: %o", error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
    },
    async fn_getNoiDungGhiChu() {
      try {
        const response = await mushroom.dang_ky_ghi_chu.listAsync({
          fields: "id,dang_ky_id,noi_dung,thoi_diem_tao,nguoi_tao_id",
          filters: ["dang_ky_id=" + this.$router.currentRoute.params.id], // or "your filters" ,
          sort: "-thoi_diem_tao",
        });
        let noiDung = await this.fn_changeDataPhanHoiGhiChu(response.result);
        this.danhSachGhiChu = [];
        noiDung.forEach((item) => {
          this.danhSachGhiChu.push({
            noi_dung: item.noi_dung,
            thoi_diem_tao: item.thoi_diem_tao,
          });
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },

    fn_cancel() {
      this.fn_resetForm();
      this.$router.push({
        name: "DanhSachDangKyDongHo",
      });
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    submitForm(data) {
      this.dialogThongBao = true;
      this.thong_bao_user = false;
      this.thong_bao_server = false;
      this.thong_bao_duyet = true;
      this.mData.dataApplyServicePack = data.dataApply;
    },
    handleCloseDialogChooseService() {
      this.showFormService.show = false;
    },
  },

  async created() {
    this.routerName = this.$router.currentRoute.name;
    await this.fn_initForm();
    await this.fn_getNoiDungPhanHoi();
    await this.fn_getNoiDungGhiChu();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .flower-spinner {
  background-color: #fff;
}
.btn-group {
  display: flex;
  justify-content: center;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 20px;
}
::v-deep .error .el-input__inner {
  background-color: #ff888847;
  border: 1px solid #ffbbbb;
}
.loadingPage {
  position: absolute;
  z-index: 10;
  height: 100%;
  width: 100%;
  background-color: #fff;
}
.spinner {
  top: 50%;
  left: 50%;
  width: 60px !important;
  height: 60px !important;
}
.lich-su {
  margin-bottom: 8px;
  &__time,
  &__ghi-chu {
    min-width: 123px;
    width: fit-content;
    border-radius: 12px;
    padding: 0 7px;
    line-height: 18px;
    background-color: #f56c6ce6;
    color: #ffffff;
    font-weight: 600;
    font-size: 12px;
    margin-bottom: 5px;
  }
  &__ghi-chu {
    background-color: #67c23a;
  }
  &__content {
    padding-left: 10px;
  }
}
::v-deep .collapse-content .el-collapse-item__content {
  max-height: 326px;
  overflow: auto;
}
.collapse-content__time {
  display: flex;
  .fa-user {
    color: rgb(48, 146, 238);
    margin-right: 5px;
  }
  .fa-user-headset {
    color: rgb(1, 151, 63);
    margin-right: 5px;
  }
}
.group-btn-email button {
  margin-left: 0;
}
.value-list {
  background: rgb(102, 177, 255);
  margin-left: 5px;
  height: 20px;
  line-height: 22px;
  border-radius: 10px;
  color: #fff;
  text-indent: initial;
  padding: 0 10px;
}
.link_agent {
  display: flex;
  justify-content: space-between;
  &__text {
    color: #009ad0;
    width: 65px;
    margin-left: 15px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
